<template>
    <div class="login-container">
        <div class="login-panel">
            <img src="../../assets/images/navitas_logo_white.png" alt="Navitas Safetey Group">
            <text-input autocomplete="username email" name="email" label="E-mail / Username" hint="If you confirmed email, login with it, not username."
                        ref="username" @keyup.enter.native="actionLogin"/>
            <password-input autocomplete="current-password" name="password" label="Password" ref="password" @keyup.enter.native="actionLogin" 
                           :has-error="loginError" :error-message="loginErrorMessage"/>

            <text-input label="2 Factor Authentication Code" hint="Enter the code provided from your google authenticator app."
                        ref="code" @keyup.enter.native="actionLogin" v-if="showFACode" />

            <text-button label="Sign in" :loading-state="loadingState" @click="actionLogin"/>
            <div style="display: flex; align-items: stretch;">
                <div class="login-link">
                    <a @click="actionFederatedEmailLogin">Sign in Using SSO</a>
                </div>
                <div class="forgot-password-link">
                    <a @click="actionForgotPassword">Forgot your password?</a>
                </div>
            </div>
        </div>
        <login-notice />
    </div>
</template>
<style>
.md-color-orange {
    color: #f1934b;
}
</style>
<script>
import TextInput from "../components/TextInput";
import PasswordInput from "../components/PasswordInput";
import TextButton from "../components/TextButton";
import {mapMutations} from "vuex";
import AuthService from "../../new/services/AuthService";
import LoginNotice from "../components/LoginNotice";

export default {

    name: "Login",
    components: {LoginNotice, TextButton, PasswordInput, TextInput},
    data() {
        return {
            loadingState: false,
            showFACode: false,
            loginError: false,
            loginErrorMessage: '',
            failedAttempts: 0,
            maxFailedAttempts: 3
        }
    },
    methods: {
        actionLogin() {
            // Clear previous errors
            this.loginError = false;
            this.loginErrorMessage = '';
            
            this.loadingState = true;
            
            this.$api.login({
                data: {
                    grant_type: 'password',
                    username: this.$refs.username.value,
                    password: this.$refs.password.value,
                    code: Object.prototype.hasOwnProperty.call(this.$refs, "code") ? this.$refs.code.value : null,
                }
            }).then(({data}) => {
                
                // Reset failed attempts on successful login
                this.failedAttempts = 0;
                
                // Attempt to login the user
                AuthService.login(data)

                // On success, redrect to correct dashboard
                AuthService.redirectUserToTheOldAppOrDashboard();

            }).catch(({data, error}) => {
                
                // Did the login fail because a 2FA code is required? 
                if (data !== undefined && data !== null) {
                    if (Object.prototype.hasOwnProperty.call(data, "_2fa_enabled") === true) {
                        if (data._2fa_enabled === 1) {
                            this.showFACode = true;
                            return; // Don't count this as a failed attempt
                        }
                    }
                }

                // Other error
                if (error !== undefined && error !== null && error.status === 418) {
                    const token = data.token ?? '';
                    const email = data.email ?? '-';
                    let routePath = this.$enums.RoutePathEnum.ACCOUNT_CONFLICT;
                    routePath = routePath.replace(':token', token);
                    routePath = routePath.replace(':email', email);
                    this.$router.push(routePath);
                    return; // Don't count this as a failed attempt
                }

                // Handle login failure
                this.failedAttempts++;
                this.loginError = true;
                this.loginErrorMessage = 'Invalid account or password. Click the eye icon to reveal password.';

                // Check if we've reached the maximum failed attempts
                if (this.failedAttempts >= this.maxFailedAttempts) {
                    // Redirect to forgot password page
                    this.actionForgotPassword();
                }

            }).finally(() => {
                this.loadingState = false;
            });

        },
        actionForgotPassword() {
            this.$router.push(this.$enums.RoutePathEnum.FORGOT_PASSWORD);
        },
        actionFederatedEmailLogin() {
            this.$router.push(this.$enums.RoutePathEnum.FEDERATED_EMAIL_LOGIN);
        },
        ...mapMutations('app', {
            setGlobalLoadingState: 'setGlobalLoadingState',
        })
    },
    mounted() {
        if (AuthService.isLogged()) {
            this.$router.push(this.$enums.RoutePathEnum.DASHBOARD);
        }

        let confirmEmailToken = this.$route.query.confirmEmailToken ?? '';

        if (confirmEmailToken.length > 0) {
            this.setGlobalLoadingState(true);
            this.$api.confirmEmail({
                data: {
                    token: confirmEmailToken
                }
            }).then(({data}) => {
                AuthService.login(data)
                /* Delay for setting cookies */
                setTimeout(() => {
                    this.setGlobalLoadingState(false);
                    this.$router.push(this.$enums.RoutePathEnum.DASHBOARD);
                }, 10);
            }).finally(() => {
                this.setGlobalLoadingState(false);
                this.$router.push(this.$enums.RoutePathEnum.LOGIN)
            });
        } else {
            this.setGlobalLoadingState(false);
        }
    }
}
</script>
